// The sidebar used to highlight whatever the user last CLICKED, which went
// stale the moment they moved around inside the app — open an info-screen
// template and the rail still said Slides. Pages report where they actually
// are and the sidebar follows.
//
// This lives in its own module rather than in App.js so SlideBuilder can import
// it without App.js -> SlideBuilder -> App.js becoming a cycle.
export function announceSub(sub) {
  try { window.dispatchEvent(new CustomEvent('menuapp:sub', { detail: { sub } })); } catch {}
}
